module.exports = __webpack_public_path__ + "img/table-rows.077d88ed.svg";